// extracted by mini-css-extract-plugin
export var author = "search-result-module--author--8e7bb";
export var category = "search-result-module--category--8b912";
export var excerpt = "search-result-module--excerpt--55b84";
export var headline = "search-result-module--headline--3e6e1";
export var headlinePost = "search-result-module--headline-post--69053";
export var paragraph = "search-result-module--paragraph--aefc8";
export var searchResult = "search-result-module--search-result--2af42";